// lineChartSlice.js
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import {
  setSnackBar,
  showLoadingScreen,
} from "../../reusable_components/site_data/siteDataSlice";
import { backend_url } from "../../App";
import { selectFilters } from "../filters/filterSlice";

export const lineChartSlice = createSlice({
  name: "line_chart",
  initialState: {
    line_chart: {
      labels: [],
      datasets: [],
    },
    timeRange: "3 months",
    loading: false,
  },
  reducers: {
    setLineChart: (state, action) => {
      state.line_chart = {
        labels: action.payload.labels,
        datasets: action.payload.datasets,
      };
    },
    setTimeRange: (state, action) => {
      state.timeRange = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

// Export the reducer as default
export default lineChartSlice.reducer;

// Export actions
export const { setLineChart, setTimeRange, setLoading } =
  lineChartSlice.actions;

// Export selectors
export const selectLineChart = (state) => state.line_chart;
export const selectTimeRange = (state) => state.line_chart.timeRange;
export const selectLoading = (state) => state.line_chart.loading;

// Export the thunk
const Header = {};
export const getLineChart = (start_date, end_date) => (dispatch, getState) => {
  dispatch(showLoadingScreen(true));
  dispatch(setLoading(true));
  Header["Authorization"] = `Token ${localStorage.getItem("token")}`;
  let config = {
    headers: Header,
  };
  const filters = selectFilters(getState());
  let cameras_selected = filters.cameras.join(",");
  let species_selected = filters.species.join(",");

  // Format dates for API - Ensure they are exactly YYYY-MM-DD
  const formattedStartDate = start_date.slice(0, start_date.indexOf("T"));
  const formattedEndDate = end_date.slice(0, end_date.indexOf("T"));

  axios
    .get(
      `${backend_url}/core/api/event/linechart/?date_gte=${formattedStartDate}&date_lte=${formattedEndDate}&cameras=${cameras_selected}&species=${species_selected}`,
      config,
    )
    .then((res) => {
      dispatch(setLineChart(res.data));
    })
    .catch((err) => {
      dispatch(setSnackBar(err.message));
    })
    .finally(() => {
      dispatch(showLoadingScreen(false));
      dispatch(setLoading(false));
    });
};
